/**
 * @generated SignedSource<<a1b029fbcf755de86e966161bb716df2>>
 * @relayHash 8159816e590e8998e27034f528353acd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ea9349f4dca79a4085cba40608561e0bd671e7dfef19561fdd213fe12fe2921a

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraBusinessFormAppMemoQuery } from './JiraBusinessFormAppMemoQuery.graphql';

const node: PreloadableConcreteRequest<JiraBusinessFormAppMemoQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "ea9349f4dca79a4085cba40608561e0bd671e7dfef19561fdd213fe12fe2921a",
    "metadata": {},
    "name": "JiraBusinessFormAppMemoQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
